import React from 'react';
import { useTranslate } from 'react-admin';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, makeStyles, Typography } from '@material-ui/core';
import BackupIcon from '@material-ui/icons/Backup';
import { useUploader } from '../Uploader';
import { useQuery } from 'react-query';
import { getAllTags } from '../../../../services/file-explorer/fileExplorerApi';
import { concatenateFileSystemNodePathToFilePath } from '../../../../services/file-explorer/uploader/uploaderUtils';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { getTagFormDependencies } from '../../../../services/file-explorer/tags/tagFormInputRepository';
import GridTagFields from '../../tags/GridTagFields';

const useStyles = makeStyles((theme) => ({
    files: {
        boxShadow: 'none',
        border: `1px solid ${theme.palette.divider}`,
            '&:not(:last-child)': {
            borderBottom: 0,
        },
    },
    fileListSummary: {
    },
    fileList: {
        display: 'block',
        overflowX: 'hidden',
        wordWrap: 'break-word',
        borderTop: `1px solid ${theme.palette.divider}`,
            '&:not(:last-child)': {
            borderBottom: 0,
        },
        '&:before': {
            display: 'none',
        },
    },
    filePath: {
        marginTop: 10,
        marginBottom: 10
    }
}));

function UploaderAddDialog(props) {
    const { open, files, fileSystemNodePath, handleCancel } = props;

    const translate = useTranslate();
    const classes = useStyles();
    const uploader = useUploader();

    const { data: tagGroups } = useQuery('/file-explorer/tag', getAllTags);
    const { mandatoryTagGroups, optionalTags, fields, defaultValues } = getTagFormDependencies(tagGroups, translate);

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(yup.object().shape(fields)),
        mode: 'onChange',
        criteriaMode: 'all',
        defaultValues: defaultValues,
    });

    function resetDialog() {
        reset();
    }

    function handleOnClickUpload(data) {
        let tagIds = [];
        for (var fieldName in data) {
            if (isFieldNameTagFieldName(fieldName)) {
                for (var tag of data[fieldName]) {
                    tagIds.push(tag.id);
                }
            }
        }
        uploader.addFilesToUploadQueue(files, tagIds);
        handleCancel();
    }

    function isFieldNameTagFieldName(fieldName) {
        return fieldName.startsWith('mandatory_tag_group_') || fieldName == 'optional_tags';
    }

    function handleCancelInternal() {
        handleCancel();
    }

    const slashConcatenatedFileSystemNodePath = fileSystemNodePath.join('/');
    return (
        <Dialog open={open} TransitionProps={{onEnter: resetDialog, onClose: handleCancelInternal}} fullWidth={true} maxWidth="md">
            <DialogTitle>{translate(`cmss.resources.file-explorer.uploader.dialog.upload`)}</DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <GridTagFields control={control} errors={errors} mandatoryTagGroups={mandatoryTagGroups} optionalTags={optionalTags}/>
                    <Divider/>
                    <Grid item xs={12}>
                        <Accordion className={classes.files} TransitionProps={{ unmountOnExit: true }} >
                            <AccordionSummary className={classes.fileListSummary} expandIcon={<ExpandMoreIcon />}>
                                <Typography>{translate(`cmss.resources.file-explorer.uploader.dialog.list-of-files`)} ({files.length})</Typography>
                            </AccordionSummary>
                            <AccordionDetails className={classes.fileList}>
                                {
                                    files.map((file) => (
                                        <Typography className={classes.filePath} variant={'body2'} key={file.path}>
                                            {
                                                concatenateFileSystemNodePathToFilePath(slashConcatenatedFileSystemNodePath, file.path)
                                            }
                                        </Typography>
                                    )) 
                                }
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant={'contained'} onClick={handleCancelInternal} color={'default'}>
                    {translate(`cmss.resources.file-explorer.uploader.dialog.cancel`)}
                </Button>
                <Button variant={'contained'} color={'primary'} onClick={handleSubmit(handleOnClickUpload)} startIcon={<BackupIcon />}>
                    {translate(`cmss.resources.file-explorer.uploader.dialog.upload`)}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default UploaderAddDialog;